import { PropsWithChildren } from 'react'
import { BrowserRouter } from 'react-router-dom'
import { CssBaseline } from '@mui/material'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3'

import { HeapProvider } from './Heap'
import QueryProvider from './Query'
import { SessionProvider } from './Session'
import ThemeProvider from './Theme'

export default function AppProvider({ children }: PropsWithChildren): JSX.Element {
  return (
    <BrowserRouter>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <SessionProvider>
          <HeapProvider>
            <QueryProvider>
              <ThemeProvider>
                <CssBaseline />
                {children}
              </ThemeProvider>
            </QueryProvider>
          </HeapProvider>
        </SessionProvider>
      </LocalizationProvider>
    </BrowserRouter>
  )
}
